import { render, staticRenderFns } from "./CandidateSearch.vue?vue&type=template&id=4acad034&scoped=true&"
import script from "./CandidateSearch.vue?vue&type=script&lang=js&"
export * from "./CandidateSearch.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSearch.vue?vue&type=style&index=0&id=4acad034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acad034",
  null
  
)

export default component.exports